import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  /**
   * Constructor
   */
  constructor(private translate: TranslateService) {}

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clone the request object
    let newReq = req.clone();
    
    newReq = req.clone({
      headers: req.headers
                .set('Accept-Language',
                  this.translate?.store?.currentLang && this.translate?.store?.currentLang !== null 
                  ? this.translate?.store?.currentLang
                  : this.translate.defaultLang
                )
    });

    // Response
    return next.handle(newReq).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }
}
